import { useId } from "react";

import { useDroppable } from "@dnd-kit/core";

import { DRAGGABLE_TYPES } from "../constants";
import DndIndicator from "../Indicator";

const SectionPlaceholder = ({ data, index = 0 }) => {
  const id = useId();

  const { isOver, setNodeRef } = useDroppable({
    data: { ...data, accepts: [DRAGGABLE_TYPES.SECTION], index },
    id: `droppable-section--${id}`,
  });

  return (
    <div className="relative" ref={setNodeRef}>
      {isOver && <DndIndicator layout="vertical" />}
    </div>
  );
};

export default SectionPlaceholder;
